import styled from "styled-components";

const Pill = styled.p`
  display: flex;
  font-weight: 700;
  color: #fff;
  padding: 9px 39px;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 1.413rem;
  letter-spacing: 1px;
  text-transform: capitalize;
  margin: 5px;
  border-radius: 34.5px;
  width: 150px;
  background-color: #dfdfdf;
  &.high {
    background-color: #e16408;
  }
  &.low {
    background-color: #00abab;
  }
  &.unknown {
    background-color: #263238;
  }
`;

export { Pill };
